// extracted by mini-css-extract-plugin
export default {"footerSocialContent":"FooterSocial_footerSocialContent__RcVTD","socialTitle":"FooterSocial_socialTitle__fMxjA"};